import { useState } from 'react'
import styled from 'styled-components'

import FaqListItem from '~/features/faq/components/FaqListItem'
import FaqTabs from '~/features/faq/components/FaqTabs'
import { useFaqCategory, useFaqList } from '~/features/faq/queries/useFaq'
import { type Filters } from '~/features/faq/types/faq'
import LoadingScreen from '~/shared/components/loading/LoadingScreen'
import NoData from '~/shared/components/NoData'
import Pagination from '~/shared/components/pagination/Pagination'
import theme from '~/shared/styles/theme'

function FaqList() {
  const [filters, setFilters] = useState<Filters>({
    page: 1,
    row_per_page: 10,
    category_code: 'C0500001',
  })

  const { data: tabOptions, isLoading: categoryLoading } = useFaqCategory()
  const { data: faq, isLoading: faqLoading } = useFaqList(filters)

  if (categoryLoading || faqLoading) return <LoadingScreen />

  const { list, pageInfo } = faq!

  const handleChangeTab = (tab: string) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      category_code: tab,
      page: 1,
    }))
  }

  const handleChangePage = (event: React.ChangeEvent<HTMLElement> | null) => {
    const page = Number(event?.target.innerText)
    setFilters((prevFilters) => ({ ...prevFilters, page }))
  }

  return (
    <Wrapper>
      <HeaderBox>
        <FaqTabs
          tabContents={tabOptions}
          selectedTab={filters.category_code}
          $size="sm"
          setSelectTab={handleChangeTab}
        />
      </HeaderBox>
      <>
        {list.length === 0 ? (
          <NoDataWrapper>
            <NoData />
          </NoDataWrapper>
        ) : null}
      </>
      {list.map((item) => (
        <FaqListItem key={item.id} data={item} />
      ))}
      {list.length > 0 && (
        <PaginationWrapper
          page={filters.page}
          count={pageInfo.max_page}
          onChange={handleChangePage}
        />
      )}
    </Wrapper>
  )
}

export default FaqList

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  box-sizing: border-box;
  width: 100%;
  padding: 24px 36px;

  background-color: white;
  border: 1px solid #c1c3c2;
  border-radius: 12px;

  @media ${theme.device.medium} {
    gap: 20px;
    padding: 20px 24px;
  }
`

const HeaderBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  @media ${theme.device.medium} {
    flex-direction: column;
    gap: 24px;
  }
`

const NoDataWrapper = styled.div`
  width: 100%;
  height: 100%;
`

const PaginationWrapper = styled(Pagination)`
  display: flex;
  justify-content: center;
  margin: 0 auto;

  button {
    font-size: 14px;
    font-weight: 500;
    font-style: normal;
    line-height: 20px;
    color: #6b7280;
  }

  .Mui-selected {
    color: ${theme.colors.mint_3};
    background-color: transparent;
    border: none;
    border-radius: 10px;
  }
`
